import React, { useContext, useState } from "react";
import { GlobalContext } from "../../../Context/GlobalContext";
import Navbar from "./Navbar";
import AccountOverview from "./AccountOverview";
import EditProfilePage from "./EditProfilePage";
import ChangePasswordPage from "./ChangePasswordPage";
import PaymentMethodPage from "./PaymentMethodPage";
import PurchasedContentPage from "./PurchasedContentPage";
import BillingPage from "./BillingPage.js";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import SubscriptionsPage from "./SubscriptionsPage";
import InvoicesPage from "./InvoicesPage";
import OverLay from "../Modals/OverLay";
import { Switch, Route, useRouteMatch, Redirect } from "react-router-dom";
import SnackBar from "../Notification/SnackBar";

// Contains the pages and routes for the viewer's account
const AccountSettingsPage = () => {
  const { viewerObj, setViewerObj, connectedStripeId, companyEndpoint } =
    useContext(GlobalContext);
  const [visible, setVisible] = useState(false);
  const [snack, setSnack] = useState({
    show: false,
    type: "error",
    message: "",
  });
  const { path } = useRouteMatch();

  // if the client is not signed in redirect back to the homepage
  if (!viewerObj) return <Redirect to={`/${companyEndpoint}`} />;

  return (
    <>
      <OverLay visible={visible} />
      <SnackBar
        open={snack.show}
        setOpen={(value) => {
          setSnack((prev) => {
            return { ...prev, message: "", type: "error", show: value };
          });
        }}
        type={snack.type}
        message={snack.message}
        verticalPosition={"top"}
        horizontalPosition={"right"}
      />
      {viewerObj?._id && (
        <Container maxWidth="lg">
          <Grid container wrap="nowrap" spacing={8}>
            {/* side navbar */}
            <Grid item container alignContent="flex-start" lg={3}>
              <Navbar
                path={path}
                viewerObj={viewerObj}
                connectedStripeId={connectedStripeId}
                companyEndpoint={companyEndpoint}
              />
            </Grid>

            {/* container for routes */}
            <Grid item lg={9}>
              <Switch>
                {/* <Route
                  exact
                  path={`${path}`}
                  render={() => <AccountOverview viewerObj={viewerObj} />}
                /> */}

                <Route
                  exact
                  path={`${path}`}
                  render={() => (
                    <EditProfilePage
                      viewerObj={viewerObj}
                      setViewerObj={setViewerObj}
                      connectedStripeId={connectedStripeId}
                    />
                  )}
                />

                <Route
                  path={`${path}/change-password`}
                  render={() => (
                    <ChangePasswordPage
                      viewerObj={viewerObj}
                      setViewerObj={setViewerObj}
                    />
                  )}
                />
                {connectedStripeId && viewerObj?.stripeId && (
                  <>
                    {viewerObj?.subscription?.id && (
                      <Route
                        path={`${path}/subscriptions`}
                        render={
                          () => (
                            // !viewerObj?.subscription?.id ||
                            // !viewerObj.stripeId ? (
                            //   <Redirect
                            //     to={`/${companyEndpoint}/subscriptions`}
                            //   />
                            // ) : (
                            <SubscriptionsPage
                              viewerObj={viewerObj}
                              updateShow={(val) => setVisible(val)}
                              setSnack={setSnack}
                            />
                          )
                          // )
                        }
                      />
                    )}

                    <Route
                      path={`${path}/purchases`}
                      render={() => (
                        <PurchasedContentPage viewerObj={viewerObj} />
                      )}
                    />
                    <Route
                      path={`${path}/invoices`}
                      render={() => <InvoicesPage viewerObj={viewerObj} connectedStripeId={connectedStripeId} /> }
                    />
                    <Route
                      path={`${path}/billing`}
                      render={() => (
                        <BillingPage
                          viewerObj={viewerObj}
                          connectedStripeId={connectedStripeId}
                        />
                      )}
                    />
                    <Route
                      path={`${path}/payment-method`}
                      render={() => (
                        <PaymentMethodPage
                          viewerObj={viewerObj}
                          connectedStripeId={connectedStripeId}
                        />
                      )}
                    />
                  </>
                )}
              </Switch>
            </Grid>
          </Grid>
        </Container>
      )}
    </>
  );
};

export default AccountSettingsPage;
